import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { REMOVE_SALES_ARGUMENT } from "../sales-argument.queries";
import {
  RemoveSalesArgumentMutation,
  RemoveSalesArgumentMutationVariables,
} from "../../../__generated__/RemoveSalesArgumentMutation";

export const useRemoveSalesArgument = () => {
  return useMutation<RemoveSalesArgumentMutation, RemoveSalesArgumentMutationVariables>(
    REMOVE_SALES_ARGUMENT,
    {
      refetchQueries: ["SalesArgumentsQuery"],
      update(cache) {
        evictFields(cache, ["salesArgument", "salesArguments"]);
      },
    }
  );
};
